


















import { Component, Vue } from "vue-property-decorator";
import validate from "@/directives/validate";
import vSelect from "vue-select";
import moment from "moment";
import { setMassForceOn } from "@/services/solutions/solutionService";

@Component({
    components: {
        vSelect
    },
    directives: { validate }
})
export default class ForceOnModal extends Vue {
    forceOn = "";
    // computed
    get timeIntervals(): string[] {
        const timeIntervals = [];
        const currentHour = moment(new Date()).hour();
        const startHour = currentHour + 1;
        for (let i = startHour; i < 24; i++) {
            timeIntervals.push(`${i < 10 ? 0 : ""}${i}:00`);
        }

        for (let i = 0; i <= currentHour; i++) {
            timeIntervals.push(`${i < 10 ? 0 : ""}${i}:00`);
        }

        return timeIntervals;
    }

    resetState() {
        this.forceOn = "";
    }

    setForceOn(timeInterval: string) {
        const timeValues = timeInterval.split(":");
        const currentHour = moment(new Date()).hour();
        const selectedHour = Number(timeValues[0]);
        const date = currentHour >= selectedHour ? moment().add(1, "d") : moment();
        date.hour(selectedHour);
        date.minute(0);
        date.second(0);
        this.forceOn = date.toDate().toLocaleString("en-US");
    }

    save() {
        setMassForceOn(this.forceOn).then(() => {
            this.$bvModal.hide("modal-playerForceOn");
        });
    }
}
